export const OPEN_FORGOT_PASSWORD = '@auth/OPEN_FORGOT_PASSWORD';
export const CLOSE_FORGOT_PASSWORD = '@auth/CLOSE_FORGOT_PASSWORD';

export const OPEN_TERMS = '@auth/OPEN_TERMS';
export const CLOSE_TERMS = '@auth/CLOSE_TERMS';
